// extracted by mini-css-extract-plugin
export default {"shimmer":"ErrorPage_shimmer__ZUTlw","dark_shimmer":"ErrorPage_dark_shimmer__eut-5","error_page":"ErrorPage_error_page__1dwyw","error_in":"ErrorPage_error_in__fQYS3"};